module.exports = __webpack_public_path__ + "static/media/V_pictos-04.5f311732.svg";